import { Reducer } from 'redux';
import { AccessControlState, AccessControlTypes } from './types';

const INITIAL_STATE: AccessControlState = {
  pagination: undefined,
  data: [],
  loading: false,
};

const reducer: Reducer<AccessControlState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AccessControlTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AccessControlTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case AccessControlTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
